import { atom } from "@reatom/framework";
import { ExportJobDto } from "definitions/exporter";

export const selectJobAtom = atom<ExportJobDto | null>(null, "selectJob");
